import { E } from '@angular/cdk/keycodes';
import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriRasa } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { EditorService } from '../../editor.service';
import { PeremriVetvetorFormulaService } from './peremri-vetvetor-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriVetvetorService {

  constructor(private fb: UntypedFormBuilder, private peremriVetvetorFormulaService: PeremriVetvetorFormulaService) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriVetvetor') as UntypedFormArray;
    // this.generateVetvetoreForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {

      let index = formArray.controls.findIndex((c) => {
        c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == ''
      });
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.rasaId, item.pershkrimi);
      }
    })
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateVetvetoreForms(form.get('peremriBaza.peremriVetvetor') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriVetvetor') as UntypedFormArray;
    this.peremriVetvetorFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateVetvetoreForms(formArray: UntypedFormArray, manual: boolean) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const pr of PeremriConstants.PeremriRasat) {
      const peremriForm = this.fb.group({
        rasaId: pr.id,
        pershkrimi: '',
      });

      formArray.push(peremriForm);
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, rasa: PeremriRasa, pershkrimi?: string) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriVetvetor');
    const peremriForm = this.fb.group({
      rasaId: rasa,
      pershkrimi: pershkrimi,
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriVetvetor') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi
      })
    })

    return creationDTO;
  }

}
